// @flow
export default function getDefaultCrop(width: number, height: number, ratio: number) {
  let cropX, cropY, cropWidth, cropHeight
  if (height * ratio >= width) {
    cropWidth = width
    cropHeight = Math.floor(width / ratio)
    cropX = 0
    cropY = Math.floor((height - cropHeight) / 2)
  } else {
    cropWidth = Math.floor(height * ratio)
    cropHeight = height
    cropX = Math.floor((width - cropWidth) / 2)
    cropY = 0
  }

  return {
    x: cropX,
    y: cropY,
    width: cropWidth,
    height: cropHeight
  }
}
